import * as d3 from 'd3'

export default {

  methods: {

    draw_Index() {

      let cir = this.circle
      let stg = this.stage
      let padding = (this.circle.front.radius*2) + 20

      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)

      let cx = cir.front.radius
      stg.cols.forEach((col,i)=> {
        
        let values = chart
        .append('g')
        .attr('transform', `translate(${cx}, ${0})`)

        
        this.gmx_Line(values, 0, padding, 20, 20, '#bcbcbc', .5, 1)
        this.gmx_Line(values, 0, 0, 20, 25, '#bcbcbc', .5, 1)
        this.gmx_Line(values, padding, padding, 20, 25, '#bcbcbc', .5, 1)

        this.gmx_Text(values, '', padding/2, 0,  stg.title.tSize, stg.title.tColor,    'middle', '', col.name)
        this.gmx_Text(values, '', 0,         35, stg.header.tSize, stg.header.tColor, 'middle', '', col.fName ? col.fName : 'Start')
        this.gmx_Text(values, '', padding,   35, stg.header.tSize, stg.header.tColor, 'middle', '', col.sName ? col.sName : 'Finish')


        // Total
        values
        .append('text')
        .attr('x', padding/2).attr('y', 16)
        .attr('fill', stg.total.type == 'auto' ? col.color : stg.total.tColor)
        .attr('font-size', stg.total.tSize).attr('text-anchor', 'middle')
        .text(this.rawData[i].TOTAL)
        .call(this.event_Link, col)

        // Start
        values
        .append('text')
        .attr('x', -3).attr('y', cir.y+4)
        .attr('fill', stg.plan.tColor).attr('font-size', stg.act.tSize).attr('text-anchor', 'end')
        .text(this.rawData[i].SP)
        .call(this.event_Link, col)

        this.gmx_Text(values, '', 0,       cir.y+4, 11, '#E0E0DF', 'middle', '', `/`)

        let delta = this.gmx_deltaValue(this.rawData[i].SA - this.rawData[i].SP)
        values
        .append('text')
        .attr('x', 3).attr('y', cir.y+4)
        .attr('fill', stg.act.delta=='Y' ? delta : stg.act.tColor).attr('font-size', stg.act.tSize)
        .text(this.rawData[i].SA)
        .call(this.event_Link, col)

         // Start
        values
        .append('text')
        .attr('x', padding-3).attr('y', cir.y+4)
        .attr('fill', stg.plan.tColor).attr('font-size', stg.act.tSize).attr('text-anchor', 'end')
        .text(this.rawData[i].FP)
        .call(this.event_Link, col)

        this.gmx_Text(values, '', padding, cir.y+4, 11, '#E0E0DF', 'middle', '', `/`)

        delta = this.gmx_deltaValue(this.rawData[i].FA - this.rawData[i].FP)
        values
        .append('text')
        .attr('x', padding+3).attr('y', cir.y+4)
        .attr('fill', stg.act.delta=='Y' ? delta : stg.act.tColor).attr('font-size', stg.act.tSize).attr('text-anchor', 'start')
        .text(this.rawData[i].FA)
        .call(this.event_Link, col)

        this.draw_Circle(chart, cx, col, this.rawData[i].S_PRO) // -----> Below
        this.draw_Circle(chart, cx + padding, col, this.rawData[i].F_PRO) // -----> Below

        cx = cx + (cir.space + (cir.front.radius*2))
      })

    },

  } 
}